import { memo } from "react";

import { QuestionPlanOptionConnection } from "@/components/features/items/edit/plan/_shared/ui/components/connection/option-connection/option-connection";

import { usePlanAvailableOptionIDs } from "./hooks/use-option-connection";

export const QuestionDayTripPlanOptionConnection = memo(() => {
	const { availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs } =
		usePlanAvailableOptionIDs();

	return (
		<QuestionPlanOptionConnection
			availableItemIDs={availableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
		/>
	);
});

QuestionDayTripPlanOptionConnection.displayName = "QuestionDayTripPlanOptionConnection";
